// The columns the tables have in common (a column is written out in the table's file when it is different)

// a text column with a filter in its header
export const text = (title, field, extra = {}) => ({ title, field, filter: 'text', ...extra });

// the OSIRT ticket of the record: a link to it, or N/A
export const ticket = (title = 'Ticket') => text(title, 'osirt_ticket', { type: 'ticket', align: 'right' });
